import React, { useEffect } from "react";
import { intl } from "LocaleWrapper";

import { PageHeader, Button } from "@cofano/cck";
import { CircularProgress } from "@mui/material";

import useRequest from "components/hooks/useRequest";
import Helmet from "components/helmet/Helmet";
import { useFormDialog } from "components/dialogs/Dialogs";

import { Language } from "imports/Utils";

import AddWaterLevelDialog from "./components/dialogs/AddWaterLevelDialog";
import WaterLevelList from "./components/list/WaterLevelList";

import { WaterLevel } from "types/index";

interface WaterLevelsProps {
	hidePageTitle?: boolean;
	disableBreakPoints?: boolean;
	onChange?: (waterlevels: WaterLevel[]) => void;
}

const WaterLevels = ({ hidePageTitle, disableBreakPoints, onChange }: WaterLevelsProps) => {

	const [ personalLevels, { trigger, loading } ] = useRequest<WaterLevel[]>({ 
		defaultResponse: [], 
		url: "waterlevels/subscriptions/personal/measuring-points",
	});

	const { formDialogProps, openFormDialog } = useFormDialog<WaterLevel[]>({
		onSave: () => trigger(),
	});

	useEffect(() => {
		if (onChange) {
			onChange(personalLevels);
		}
	}, [ personalLevels ]);

	return (
		<React.Fragment>
			<PageHeader>
				{!hidePageTitle && (
					<PageHeader.Title>
						{Language("WATER_LEVELS")}
						<Helmet title={intl.formatMessage({ id: "WATER_LEVELS" })} />
					</PageHeader.Title>
				)}

				<PageHeader.Actions>
					<Button disabled={loading} onClick={() => openFormDialog(personalLevels)}>
						{Language("ADD_BUTTON")}
					</Button>
				</PageHeader.Actions>
			</PageHeader>

			{loading ? (
				<CircularProgress size={24} />
			) : (
				<WaterLevelList
					personalLevels={personalLevels}
					refetch={trigger}
					disableBreakPoints={disableBreakPoints} />
			)}

			<AddWaterLevelDialog {...formDialogProps} />
		</React.Fragment>
	);
};

export default WaterLevels;
